import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { NS } from '../U3204';
import type { U3204DisplayMessage } from '../U3204Service';
import {
  u3204ComputeConversationTokenUsage,
  u3204FormatTokenCount,
} from '../utils/u3204ComputeConversationTokenUsage';
import U3204TokenTag from './U3204TokenTag';

interface U3204TokenUsageSummaryProps {
  messages: U3204DisplayMessage[];
}

const U3204TokenUsageSummary: React.FC<U3204TokenUsageSummaryProps> = ({ messages }) => {
  const { t, i18n } = useTranslation(NS);
  const usage = useMemo(() => u3204ComputeConversationTokenUsage(messages), [messages]);

  if (usage.totalInput + usage.totalOutput === 0) {
    return null;
  }

  const inputTooltip = (t as any)('tokens.inputTooltip', { ns: NS });
  const showInput = usage.totalInput > 0;
  const showOutput = usage.totalOutput > 0;

  return (
    <div
      className="flex shrink-0 flex-wrap items-center justify-end gap-1.5"
      role="list"
      aria-label={(t as any)('tokens.summaryAria', { ns: NS })}
    >
      {showInput ? (
        <span role="listitem">
          <U3204TokenTag variant="input" title={inputTooltip}>
            {(t as any)('tokens.input', {
              ns: NS,
              count: u3204FormatTokenCount(usage.totalInput, i18n.language),
            })}
          </U3204TokenTag>
        </span>
      ) : null}
      {showOutput ? (
        <span role="listitem">
          <U3204TokenTag variant="output">
            {(t as any)('tokens.output', {
              ns: NS,
              count: u3204FormatTokenCount(usage.totalOutput, i18n.language),
            })}
          </U3204TokenTag>
        </span>
      ) : null}
    </div>
  );
};

export default U3204TokenUsageSummary;
